import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useAdminScopeOptional } from '@/contexts/AdminScopeContext';

/**
 * Tenant dropdown for the admin app. Renders only when inside AdminScopeProvider.
 */
export function AdminTenantSelector() {
  const scope = useAdminScopeOptional();
  if (!scope || scope.isLoading || scope.availableTenants.length === 0) {
    return null;
  }

  const value =
    scope.selectedTenantId ?? scope.availableTenants[0]?.value ?? '';

  return (
    <Select value={value} onValueChange={(v) => scope.setSelectedTenantId(v)}>
      <SelectTrigger className="w-[120px] h-9">
        <SelectValue placeholder="Tenant" />
      </SelectTrigger>
      <SelectContent>
        {scope.availableTenants.map((t) => (
          <SelectItem key={t.value} value={t.value}>
            {t.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
